import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';


@inject('Game2Store')
@observer
export default class GameStep5 extends Component {


    render() {
        const winnerEl = this.props.Game2Store.winners.map(
            (w, index) => {
                return (
                    <div className="team-winner" key={index}>
                        <div className={"team-name " + w.team.color}>{w.name || "Team "}</div>
                        <div className="team-score">{w.score || 0} Points</div>
                    </div>
                )
            }
        );


        this.props.Game2Store.resetGame();


        const loser = this.props.Game2Store.loser;

        var styless = {width:"100%", margin: "40px"};



        return (
            <div className="step-5">
                {
                    loser ?
                        <div>
                            <div className="winner">
                                <h1>Winner{ this.props.Game2Store.winners.length > 1 && "s"}</h1>
                                <div className="teams-winners">
                                    {winnerEl}
                                </div>
                            </div>
                            <div className="loser">
                                <h1>Loser</h1>
                                <div className="teams-loser">
                                    <div className="team-loser" key={2}>
                                        <div className={"team-name " + loser.team.color}>{loser.name || "Team "}</div>
                                        <div className="team-score">{loser.score || 0} Points</div>
                                    </div>
                                </div>
                            </div>
                        </div> :
                        <div>
                            <div className="winner">
                                <h1>Draw</h1>
                                <div className="teams-winners">
                                    <div style={styless} >
                                        {winnerEl}
                                    </div>
                                </div>
                            </div>
                        </div>

                }
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/containers/Game2/Game2Step5.js